const API_BASE = process.env.REACT_APP_API_BASE;

if (!API_BASE) {
  throw new Error("REACT_APP_API_BASE is not defined");
}

/* -------------------------------------------------------
   SESSION
------------------------------------------------------- */
export async function createSession({ lang = "auto", consent = true }) {
  const res = await fetch(`${API_BASE}/api/ChatAi/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ lang, consent })
  });

  if (!res.ok) {
    const txt = await res.text();
    throw new Error("Failed to create session: " + txt);
  }

  const data = await res.json();
  return data.sessionId;
}

export function streamReply({
  sessionId,
  text,
  lang = "auto",
  onToken,
  onDone,
  onError,
  signal
}) {
  const params = new URLSearchParams({
    sessionId,
    q: text,
    lang
  });

  const url = `${API_BASE}/api/ChatAi/stream?${params.toString()}`;

  const es = new EventSource(url, { withCredentials: true });

  const close = () => {
    try {
      es.close();
    } catch {}
  };

  if (signal) {
    signal.addEventListener("abort", close, { once: true });
  }

  /* ---------- TOKEN STREAM ---------- */
  es.addEventListener("token", (e) => {
    if (e?.data) {
      onToken?.(e.data);
    }
  });

  /* ---------- DONE ---------- */
  es.addEventListener("done", () => {
    onDone?.();
    close();
  });

  /* ---------- ERROR ---------- */
  es.addEventListener("error", (e) => {
    console.error("[assistant] SSE error", e);
    onError?.(e);
    close();
  });

  return { cancel: close };
}

/* -------------------------------------------------------
   TOOL RESULT (PHASE 2 – NON STREAM)
------------------------------------------------------- */
export async function sendToolResult({ sessionId, tool, result, lang }) {
  const res = await fetch(`${API_BASE}/api/ChatAi/tool-result`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sessionId, tool, result, lang })
  });

  if (!res.ok) throw new Error("tool-result failed");
  return res.json(); // { text, sources? }
}

/* -------------------------------------------------------
   FEEDBACK
------------------------------------------------------- */
export async function sendFeedback({ sessionId, csat, note }) {
  await fetch(`${API_BASE}/api/ChatAi/feedback/${sessionId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ csat, note })
  });
}
